import * as DOM from './utils';

export default function addMessageControl(parent) {
    const el = {
        container: DOM.createElement('div', { id: 'messageControl' }),
        text: DOM.createElement('span', { class: 'message' }),
    };

    el.text.innerText = `${this.config.opdateret}`;
    el.container.appendChild(el.text);

    parent.appendChild(el.container);
}
